import React from 'react';
import { Layout } from 'antd';
import { Link } from 'react-router-dom';
import './footer.scss';

const Footer = () => (
  <Layout.Footer className="footer">
    <div className="copyright">
      <span>© {new Date().getFullYear()} Soldi.io</span>
      <span>All rights reserved.</span>
    </div>
    <div className="legal-cta">
      <Link to="/">
        <span>Terms of Conditions</span>
      </Link>
      <Link to="/">
        <span>Privacy Policy</span>
      </Link>
    </div>
  </Layout.Footer>
);

export default Footer;
